import React from 'react'
import './styles.scss'
import Button from '../buttons/Button'
import close from './../../images/close-white.svg'
import chartIco from './../../images/chart-ico.svg';
import arrowsIco from './../../images/arrows-ico.svg';
import plateIco from './../../images/plate-ico.svg';
import moneyIco from './../../images/money-ico.svg';
import lockIco from './../../images/lock-ico.svg';
import calendarIco from './../../images/calendar-blue-ico.svg';
import percentIco from './../../images/percent-ico.svg';
import orderIco from './../../images/order-ico.svg';
import fastIco from './../../images/fast-ico.svg';
import grenkeTablet from './../../images/grenke-benefits.png';


const ModalWhyGrenke = ( props ) => {
   
    return (
        <div className="static-modal" onClick={ () => props.closeModal() }>
            <div className="modal small" onClick={(e) => e.stopPropagation()}>
                <div className="content why-grenke">
                    <div className="icons-wrap" onClick={ () => props.closeModal() }>
                        <img src={ close } alt="Zamknij" />
                    </div>
                    <div className="col-small">
                        <div className="welcome">
                            <div className="image">
                                <img src={ grenkeTablet } alt=""/>
                            </div>
                            <div className="box">
                                Why choose grenke?
                            </div>
                        </div>
                    </div>
                    <div className="col col-icons">
                        <div className="icons">
                            <div className="icon">
                                <img src={ fastIco } alt=""/>
                                <h2>Speed</h2>
                                <p>
                                    Quick and easy access to modern technologies. 
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ plateIco } alt=""/>
                                <h2>Convenience</h2>
                                <p>
                                    Equipment and leasing in one online location.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ arrowsIco } alt=""/>
                                <h2>Flexibility</h2>
                                <p>
                                    Contract terms tailored to the company's needs.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ percentIco } alt=""/>
                                <h2>Cost Management</h2>
                                <p>
                                    Better cash flow management and lower upfront VAT burden.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ calendarIco } alt=""/>
                                <h2>Easy Planning</h2>
                                <p>
                                    Fixed, equal installments without dependence on EIBOR.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ moneyIco } alt=""/>
                                <h2>100% Leasing</h2>
                                <p>
                                    Full investment cost Through Leasing – No Down Payment Needed
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ chartIco } alt=""/>
                                <h2>Growth and Liquidity</h2>
                                <p>
                                    Freeing up company resources for other sectors and expenses.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ orderIco } alt=""/>
                                <h2>Competitiveness</h2>
                                <p>
                                    Continuous optimization of company infrastructure solutions.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ lockIco } alt=""/>
                                <h2>Security</h2>
                                <p>
                                    Grenke is a global service provider since 1978.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalWhyGrenke;